export default __webpack_public_path__ + "static/media/add Family.ad711e85.png";